"use client";

import { Card } from "@mui/material";
import { useNavigate } from "react-router-dom";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import { RecoverPasswordMessages } from "@/messages/recoverPassword/recover-password.messages";

type EmailSentStepProps = {
  messages: RecoverPasswordMessages;
};
export default function EmailSentStep({ messages }: EmailSentStepProps) {
  const router = useNavigate();
  return (
    <Card>
      <MDBox
        variant="gradient"
        bgColor="dark"
        borderRadius="lg"
        coloredShadow="dark"
        mx={2}
        mt={-3}
        p={2}
        mb={1}
        textAlign="center"
      >
        <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
          {messages.temporaryPasswordSentTitle}
        </MDTypography>
      </MDBox>
      <MDBox pt={4} pb={3} px={3}>
        <MDTypography display="block" variant="button" color="text" my={1}>
          {messages.temporaryPasswordSentDescription}
        </MDTypography>
        <MDBox mt={6} mb={1}>
          <MDButton variant="gradient" color="dark" fullWidth onClick={() => router(-1)}>
            {messages.goToLogin}
          </MDButton>
        </MDBox>
      </MDBox>
    </Card>
  );
}
